import {
	ArrayField,
	BooleanField,
	ChipField,
	Show,
	SimpleShowLayout,
	SingleFieldList,
	TextField,
	useRedirect,
	useTranslate,
} from "react-admin";
import { useMemo } from "react";
import { userPreferences } from "../../utils/fakeUserPrefrences";
import CustomImageField from "../../customComponents/CustomImageField";

const CustomChipFieldWithRedirect = ({
	record,
	source,
	basePath,
	emptyText,
	redirectToResource,
	...props
}) => {
	const redirect = useRedirect();
	const handleRedirectClick = () => {
		redirect("show", `/${redirectToResource}`, record.id);
	};
	return (
		<ChipField
			onClick={handleRedirectClick}
			source={source}
			record={record}
			emptyText={emptyText}
			{...props}
		/>
	);
};

export const TimelineShow = (props) => {
	const defaultLocale = useMemo(
		() => userPreferences.defaultTranslationLanguage,
		[]
	);
	const translate = useTranslate();
	return (
		<Show {...props} title={translate("timelines.show.title")}>
			<SimpleShowLayout>
				<TextField source={`name.${defaultLocale}`} sortable={false} />
				<TextField
					source={`description.${defaultLocale}`}
					sortable={false}
				/>
				<TextField
					source={`subTitle.${defaultLocale}`}
					sortable={false}
				/>
				<TextField
					source={`completionTitle.${defaultLocale}`}
					sortable={false}
				/>
				<BooleanField source={`isChallenge`} looseValue />
				<TextField
					source={`pushNotificationTitle.${defaultLocale}`}
					sortable={false}
				/>
				<TextField
					source={`pushNotificationMessage.${defaultLocale}`}
					sortable={false}
				/>
				<CustomImageField
					customLabel="Timeline Icon"
					source="iconUrl"
				/>
				<CustomImageField
					customLabel="Timeline Completion Icon"
					source="completionIconUrl"
				/>
				<ArrayField source="badges" label="Days">
					<SingleFieldList linkType={false}>
						<CustomChipFieldWithRedirect
							source="name.ar"
							emptyText={translate("empty.module")}
							redirectToResource="badges"
						/>
					</SingleFieldList>
				</ArrayField>
			</SimpleShowLayout>
		</Show>
	);
};
